<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100">
    <path d="M50 9A41 41 0 119 50 41 41 0 0150 9m0-9a50 50 0 1050 50A50 50 0 0050 0z" />
    <path
      d="M49.73 60.61h-3.65a1.12 1.12 0 01-1.21-1.15 37.71 37.71 0 01.74-9.36 8.53 8.53 0
         012.25-4c1-1.06 2.08-2 3.16-3s2.37-2.1 3.59-3.1c2.4-2 2.11-5.48-.89-7.12a7 7 0
         00-9.8 3.45 13.7 13.7 0 00-.6 1.88c-.24.87-.64 1.18-1.54 1.07l-7.13-.86a1.26 1.26
         0 01-1.18-1.52A14.61 14.61 0 0145.57 24a20.73 20.73 0 0112.59 1.16 13.59 13.59 0
         017.65 8 10.58 10.58 0 01-1.66 10.56 37.87 37.87 0 01-5.76 5.63c-.67.58-1.31 1.2-2
         1.77a4.52 4.52 0 00-1.65 3.65c0 1.53-.1 3.05-.14 4.58a1.23 1.23 0 01-1.35
         1.35h-3.52zM54.89 71.5a5 5 0 11-5-5 5 5 0 015 5z"
    />
  </svg>
</template>

<script>
export default {
  name: "Help",
};
</script>
